import { SessionStorage } from "./sessionStorage";

class IsLoggingOutStorage extends SessionStorage {
	public constructor() {
		super({
			storageKey: "isLoggingOut",
		});
	}
}

export const isLoggingOutStorage = new IsLoggingOutStorage();
